import { useCallback } from "react";
import { useUiContext } from "@rotorstudios/fe-ui";

import { useCmeContext } from "./CMEProvider";
import type { iCropToken } from "../Data/types";

const useAssetsBreakpointFallback = (
  assetSet: string,
  context?: string,
  cropTokens?: iCropToken[],
) => {
  const { cmeAssets, getCmeAssetsByContext } = useCmeContext();
  const { breakpointActive } = useUiContext();

  const getCmeAssets = useCallback(() => {
    let assetsContext;

    if (context) {
      assetsContext = getCmeAssetsByContext(context);
    }

    return assetsContext ?? cmeAssets;
  }, [getCmeAssetsByContext, cmeAssets, context]);

  const getAssets = useCallback(
    () =>
      getCmeAssets()?.get(assetSet)?.get(breakpointActive) ||
      getCmeAssets()?.get(assetSet)?.values()?.next()?.value,
    [getCmeAssets, breakpointActive, assetSet],
  );

  const getCropToken = useCallback(
    () =>
      cropTokens && cropTokens.length > 0
        ? cropTokens.find((crop: iCropToken) =>
            crop?.breakpoints?.includes(breakpointActive),
          )?.cropToken
        : "",
    [cropTokens, breakpointActive],
  );

  return {
    cmeAssets: getAssets(),
    cropToken: getCropToken(),
  };
};

export default useAssetsBreakpointFallback;
